/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

// eslint-disable-next-line import/prefer-default-export
export function areCookiesEnabled(): boolean {
  let enabled = !!navigator.cookieEnabled;

  if (!enabled) {
    if (document) {
      document.cookie = 'testcookie=1';
      enabled = document.cookie.indexOf('testcookie=') > -1;
      document.cookie = 'testcookie=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
    }
  }

  return enabled;
}
